import React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import Stack from "../../Stack";
import Text from "../../Text";
import Radio from "../../Radio";
import Badge from "../../Badge";
import media from "../../utils/mediaQuery";
import STATES from "./consts";

var getBoxShadow = function getBoxShadow(state) {
  return function (_ref) {
    var theme = _ref.theme,
        active = _ref.active;

    var getActive = function getActive(shadow) {
      if (active) return "".concat(shadow, ", inset 0 0 0 2px ").concat(theme.orbit.paletteProductNormal);
      return shadow;
    };

    if (state === STATES.HOVER) {
      return getActive(theme.orbit.boxShadowActionActive);
    }

    return getActive(theme.orbit.boxShadowAction);
  };
};

var StyledPricingTableItem = styled.div.withConfig({
  displayName: "PricingTableItem__StyledPricingTableItem",
  componentId: "tsjz71-0"
})(["display:flex;flex-grow:1;width:100%;position:relative;background:", ";box-shadow:", ";transition:", ";border-radius:", ";padding:", ";cursor:pointer;&:hover{box-shadow:", ";}", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.paletteWhite;
}, getBoxShadow(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.durationNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.spaceMedium;
}, getBoxShadow(STATES.HOVER), function (_ref6) {
  var basis = _ref6.basis;
  return basis && css(["flex-basis:", ";"], basis);
}, function (_ref7) {
  var featureIcon = _ref7.featureIcon;
  return featureIcon && css(["", ""], media.desktop(css(["padding-top:", ";padding-bottom:", ";"], function (_ref8) {
    var theme = _ref8.theme;
    return theme.orbit.spaceLarge;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.orbit.spaceLarge;
  })));
});
StyledPricingTableItem.defaultProps = {
  theme: defaultTheme
};
var StyledBadge = styled.div.withConfig({
  displayName: "PricingTableItem__StyledBadge",
  componentId: "tsjz71-1"
})(["position:absolute;top:-", ";left:50%;transform:translate(-50%,3px);z-index:10;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.spaceMedium;
});
StyledBadge.defaultProps = {
  theme: defaultTheme
};
var Item = styled.div.withConfig({
  displayName: "PricingTableItem__Item",
  componentId: "tsjz71-2"
})([""]);

var PricingTableItem = function PricingTableItem(_ref11) {
  var name = _ref11.name,
      price = _ref11.price,
      priceBadge = _ref11.priceBadge,
      featureIcon = _ref11.featureIcon,
      badge = _ref11.badge,
      action = _ref11.action,
      _ref11$active = _ref11.active,
      active = _ref11$active === void 0 ? false : _ref11$active,
      _ref11$compact = _ref11.compact,
      compact = _ref11$compact === void 0 ? false : _ref11$compact,
      children = _ref11.children,
      onClick = _ref11.onClick,
      basis = _ref11.basis;

  var onClickHandler = function onClickHandler() {
    if (onClick) {
      onClick();
    }
  };

  return React.createElement(StyledPricingTableItem, {
    onClick: onClickHandler,
    basis: basis,
    featureIcon: !!featureIcon,
    active: active
  }, badge && React.createElement(StyledBadge, null, typeof badge === "string" ? React.createElement(Badge, {
    type: "infoInverted"
  }, badge) : badge), React.createElement(Stack, {
    flex: true,
    direction: "column",
    spacing: "condensed",
    desktop: {
      spacing: "natural"
    }
  }, featureIcon && React.createElement(Stack, {
    justify: "center",
    grow: false
  }, featureIcon), React.createElement(Stack, {
    justify: "between",
    direction: "column"
  }, React.createElement(Stack, {
    spacing: "tight",
    direction: "column",
    flex: true,
    align: "stretch",
    desktop: {
      grow: false
    }
  }, name && React.createElement(Text, {
    type: "primary",
    align: "center",
    weight: featureIcon ? "normal" : "bold"
  }, name), price && React.createElement(Text, {
    size: "large",
    weight: "bold",
    type: "primary",
    align: "center"
  }, price), priceBadge && React.createElement(Stack, {
    justify: "center",
    align: "end",
    desktop: {
      grow: false
    }
  }, priceBadge)), !compact ? React.createElement(Stack, {
    justify: "between",
    direction: "column"
  }, children && children, action && React.createElement(Stack, {
    justify: "center",
    grow: false
  }, action)) : React.createElement(Stack, {
    justify: "center",
    align: "center",
    grow: false
  }, React.createElement(Item, null, React.createElement(Radio, {
    checked: active,
    onChange: onClickHandler
  }))))));
};

export default PricingTableItem;